import type { ApiClient } from "@api/ApiClient";
import type { Document } from "@components/documents/types";
import type { LoadOfficeActionParams, LoadOfficeActionResult, PriorArt } from "./officeAction.types";

type LoadOfficeActionResponse = {
  prior_art?: PriorArt[];
  files: Document[];
};

export const loadOfficeActionApi = async (
  apiClient: ApiClient,
  { sessionId, applicationId }: LoadOfficeActionParams
): Promise<LoadOfficeActionResult> => {
  const config = { headers: { "Content-Type": "application/json" } };
  const body = JSON.stringify({ applicationId, sessionId });
  const response = await apiClient.post(`/projects/oa`, body, config);
  if (!response) throw new Error("No response from server");

  const data = (await response.json()) as LoadOfficeActionResponse;
  const priorArt = data.prior_art ?? [];
  return {
    priorArt,
    failedPriorArt: priorArt.filter((p) => !p.uploaded),
    autoContextDocuments: data.files,
  };
};
